<div class="overflow-auto h-[100vh]">
  <div class="shadow-sm top-0 sticky z-50 bg-white">
    <app-guest-top-bar></app-guest-top-bar>
  </div>
  <div class="joiner-link2">
    <app-guest-awareness></app-guest-awareness>
    <div class="joiner-band">
      <app-guest-policy-regulations></app-guest-policy-regulations>
    </div>
  </div>
  <div appInviewPort class="opacity-0 transition-opacity duration-500 ease-in-out">
    <app-guest-faq></app-guest-faq>
  </div>
  <app-guest-footer></app-guest-footer>
</div>
